import { IPrismaClientRequestRPC } from '@prisma/studio-types'

import DMMFStore from 'stores/dmmf/DMMFStore'
import ModelStore from 'stores/model/ModelStore'

import getCountQuery from 'utils/getCountQuery'
import createError from 'utils/createError'

const getAllCounts = async () => {
  const models = Object.values(ModelStore.values)

  if (DMMFStore.isPostgresDatasource) {
    const {
      error,
      data,
    } = await window.transport.request<IPrismaClientRequestRPC>({
      channel: 'prisma',
      action: 'clientRequest',
      payload: {
        data: {
          query: `prisma.$queryRaw(\`
          SELECT schemaname,relname,n_live_tup
          FROM pg_stat_user_tables
          ORDER BY n_live_tup DESC;
        \`)`,
        },
      },
    })

    if (error) {
      throw createError('getAllCounts', 'Unable to process `count` query', {
        error,
      })
    } else if (!Array.isArray(data.response)) {
      throw createError(
        'getAllCounts',
        'Malformed response for `count` query:\n\n',
        { error }
      )
    } else {
      data.response.forEach(({ relname, n_live_tup }) => {
        const model = models.find(
          m => m.dbName === relname || m.name === relname
        )
        if (!model) return
        model.update({ count: n_live_tup })
      })
    }
  } else {
    let countQuery = `prisma.$transaction([\n`
    countQuery += models.reduce((acc, model) => {
      acc += `    ${getCountQuery({ modelId: model.id })},\n`
      return acc
    }, ``)
    countQuery += `])`
    const {
      error,
      data,
    } = await window.transport.request<IPrismaClientRequestRPC>({
      channel: 'prisma',
      action: 'clientRequest',
      payload: {
        data: {
          query: countQuery,
        },
      },
    })

    if (error) {
      throw createError('getAllCounts', 'Unable to process `count` query', {
        error,
      })
    } else if (!Array.isArray(data)) {
      // `data` is expected to be an array because we sent a $transaction with multiple queries inside
      throw createError(
        'getAllCounts',
        'Malformed response for `count` query:\n\n',
        { error }
      )
    } else {
      data.forEach(({ response: count }, idx) => {
        models[idx].update({ count }) // Order of response will be the same as the request you made
      })
    }
  }
}

export default getAllCounts
